export default __webpack_public_path__ + "static/media/18-1_clouddownload.fb5eb7f3.svg";